import { route } from './../../../routes/web';
import { setMessage } from './../../../actions/setMessage';
import { request } from './../../../functions/request';
import { ParseError } from './../../../functions/error-parse';

export const reseted_request_invalid = 'reseted_request_invalid';
export const reseted_request_send = 'reseted_request_send';
export const reseted_request_valid = 'reseted_request_valid';

export function ResetedRequestInvalid() {
    return {
        type: reseted_request_invalid,
    };
}

export function ResetedRequestSend() {
    return {
        type: reseted_request_send,
    };
}

export function ResetedRequestValid() {
    return {
        type: reseted_request_valid,
    };
}

export function fetchReseted(data, onValid) {
    return function (dispatch) {
        dispatch(ResetedRequestSend());
        request(
            route.auth.reseted,
            data,
            (data) => {
                if (data.success) {
                    dispatch(ResetedRequestValid());
                    if (typeof onValid === 'function') onValid(data);
                    dispatch(setMessage('Пароль изменен', 'success'));
                    dispatch({ type: 'closeMiniModal' });
                } else {
                    if (data.msg) {
                        dispatch(setMessage(ParseError(data.msg), 'error'));
                    } else {
                        dispatch(setMessage('Неверные данные', 'error'));
                    }
                    dispatch(ResetedRequestInvalid());
                }
            },
            (error) => {
                dispatch(ResetedRequestInvalid());
            }
        );
    };
}
